<template>
    <v-container fluid>
        <v-row no-gutters v-if="reply.message.attachment.payload.text">
            <v-col v-if="agent" cols="2" align="start" style="align-content: center;">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="bot-image ml-auto"
                        :aspect-ratio="16/9"
                        positison="bottom"
                        contain
                    />
                </div>
            </v-col>
            <v-col align="start">
                <span :class="agent ? 'grey lighten-1' : ''" :style="`float: ${agent ? 'left' : 'right'}; background-color: ${mainColor}`" class="white--text rounded-xl px-3 py-3 bubble-text"> {{ reply.message.attachment.payload?.text }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters align="end" justify="end">
            <v-col cols="12" :align="agent ? 'start' : 'end'" :class="agent ? 'justify-start' : 'justify-end'" class="d-flex px-0">
                <v-img
                    v-if="reply.message.attachment.type === 'image'"
                    max-width="300px"
                    max-height="300px"
                    contain
                    :src="reply.message.attachment.payload?.url"
                />
                <!-- <video width="300" height="240" controls>
                    <source src="movie.mp4" type="video/mp4">
                    <source src="movie.ogg" type="video/ogg">
                    Your browser does not support the video tag.
                </video> -->
                <iframe
                    v-else-if="reply.message.attachment.type === 'video'"
                    width="300"
                    height="250"
                    :src="reply.message.attachment.payload?.url"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            data:
            {
                "message":
                {
                    "attachment":
                    {
                        "type":"image", 
                        "payload":
                        {
                            "text": "hello image",
                            "url":"https://www.villagecinemas.gr/ImageGen.ashx?image=/media/1932802/poster.jpg&width=254&Constrain=true", 
                            "is_reusable":true
                        }
                    }
                    // "attachment":
                    // {
                    //     "type":"video", 
                    //     "payload":
                    //     {
                    //         "text": "hello image",
                    //         "url":"https://www.youtube.com/embed/DBLF2-qpyeU", 
                    //         "is_reusable":true
                    //     }
                    // }
                }
            }
        }),
        methods: {
        }
    }
</script>

<style scoped src="../../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>